import { combineReducers } from 'redux'
import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default combineReducers({
  searchesRequest: redukers.request({
    start: actionTypes.FETCH_SEARCHES,
    success: actionTypes.SEARCHES_SUCCESS,
    error: actionTypes.SEARCHES_ERROR,
  }),
  searches: redukers.value(
    {
      set: actionTypes.SET_SEARCHES,
      reset: actionTypes.CLEAR_SEARCHES,
    },
    [],
  ),
  removeRequest: redukers.request({
    start: actionTypes.REMOVE,
    success: actionTypes.REMOVE_SUCCESS,
    error: actionTypes.REMOVE_ERROR,
  }),
  searchDetailsRequest: redukers.request({
    start: actionTypes.FETCH_SEARCH_DETAILS,
    success: actionTypes.SEARCH_DETAILS_SUCCESS,
    error: actionTypes.SEARCH_DETAILS_ERROR,
  }),
  searchDetailsFilters: redukers.value(
    {
      set: actionTypes.SET_SEARCH_DETAILS_FILTERS,
      reset: actionTypes.CLEAR_SEARCH_DETAILS_FILTERS,
    },
    { pages: 0, page: 0 },
  ),
  searchDetailsResults: redukers.entities({
    update: actionTypes.SET_SEARCH_DETAILS_RESULTS,
    mergeById: actionTypes.MERGE_SEARCH_DETAILS_RESULTS,
    reset: actionTypes.CLEAR_SEARCH_DETAILS_RESULTS,
  }),
  getSearchOptions: redukers.request({
    start: actionTypes.GET_SEARCH_OPTIONS,
    clear: actionTypes.CLEAR_SEARCH_OPTIONS,
  }),
  searchOptions: redukers.value(
    {
      set: actionTypes.SET_SEARCH_OPTIONS,
      reset: actionTypes.CLEAR_SEARCH_OPTIONS,
    },
    [],
  ),
  searchToSave: redukers.value(
    {
      set: actionTypes.SET_SEARCH_TO_SAVE,
      reset: actionTypes.CLEAR_SEARCH_TO_SAVE,
    },
    [],
  ),
  saveSearchRequest: redukers.request({
    start: actionTypes.SAVE,
    success: actionTypes.SAVE_SUCCESS,
    error: actionTypes.SAVE_ERROR,
  }),
  addVendorRequest: redukers.request({
    start: actionTypes.ADD_VENDOR,
    success: actionTypes.ADD_VENDOR_SUCCESS,
    error: actionTypes.ADD_VENDOR_ERROR,
  }),
})
